import { render, staticRenderFns } from "./RegisteredCard.vue?vue&type=template&id=084c01ec&scoped=true&"
import script from "./RegisteredCard.vue?vue&type=script&lang=js&"
export * from "./RegisteredCard.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredCard.vue?vue&type=style&index=0&id=084c01ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c01ec",
  null
  
)

export default component.exports